import TimelineEditingLeaseProvider from './TimelineEditingLeaseProvider'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from '@/store/store-hooks'
import { TimelineAssetActions } from '../store/slice'

type TimelineAssetRootProps = {
  children: React.ReactNode
}

/**
 * Root wrapper for all timeline routes.
 * Loads the active matter's living timeline (and resumes any in-flight update polling).
 */
export default function TimelineAssetRoot({ children }: TimelineAssetRootProps) {
  const dispatch = useAppDispatch()
  const { matterId } = useParams<{ matterId: string }>()

  useEffect(() => {
    if (matterId) {
      dispatch(TimelineAssetActions.fetchAssetForMatter({ matterId }))
    }
  }, [dispatch, matterId])

  return <TimelineEditingLeaseProvider>{children}</TimelineEditingLeaseProvider>
}
